<template>
	<CommonFormInputText v-model="config.webhook" title="Dirección de webhook" placeholder="Ingrese la dirección" />
</template>

<script>
	import { computed } from 'vue';

	export default {
		emits: ['update:modelValue'],
		props: {
			modelValue: Object
		},
		setup(props, { emit }) {
			const config = computed({
				get: () => props.modelValue ?? {},
				set: (val) => {
					emit('update:modelValue', (val) ? val : null);
				}
			});

			return { config };
		}
	}
</script>